const value = {
    confirmDeleteUnit: 'Вы уверены, что хотите удалить юнит ?',
    deleteUnit: 'Удалить юнит',
    createUnitLabel: 'Создавайте здесь юниты с теорией, квизом и практикой',
    createUnit: 'Создать юнит',
    withoutContext: 'Без Контекста',
    newUnit: 'НОВЫЙ ЮНИТ',
    noUnits: 'Нет юнитов',
  };

export default value;
